(function () {
  'use strict';
  const key = '__atelierIllustrations';
  if (window[key]) { window[key](); return; }
  let trigger;
  const refresh = () => {
    const dialog = document.getElementById('ap-figure-dialog');
    document.querySelectorAll('.ap-figure__ouvrir').forEach(button => {
      button.disabled = !dialog || typeof dialog.showModal !== 'function';
    });
  };
  window[key] = refresh;
  document.addEventListener('click', event => {
    const dialog = document.getElementById('ap-figure-dialog');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    if (event.target === dialog) {
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      return;
    }
    const button = event.target.closest?.('.ap-figure__ouvrir:enabled');
    const image = !button && window.matchMedia('screen and (max-width: 999px) and (pointer: coarse)').matches &&
      event.target instanceof HTMLImageElement && event.target.closest('#main .ap-zone, #main .article-content .prose') &&
      !event.target.closest('a, button, [role="button"], [role="dialog"], dialog, .ap-hero__figure, .ap-hero__image, .article-banner, .ap-lecture, .ap-vitrine, .ap-produit-vedette') ? event.target : null;
    if ((!button && !image) || dialog.open || (!button && event.defaultPrevented)) return;
    const source = button ? button.dataset.apFigureSrc : image.currentSrc || image.src;
    if (!source) return;
    const img = new Image();
    img.alt = button ? button.dataset.apFigureAlt || '' : image.alt;
    img.width = button ? Number(button.dataset.apFigureLargeur) || 1 : Number(image.getAttribute('width')) || image.naturalWidth || 1;
    img.height = button ? Number(button.dataset.apFigureHauteur) || 1 : Number(image.getAttribute('height')) || image.naturalHeight || 1;
    if (image && image.srcset) {
      img.srcset = image.srcset;
      img.sizes = '94vw';
    }
    dialog.style.setProperty('--ap-figure-grand-ratio', String(img.width / img.height));
    dialog.setAttribute('aria-busy','true');
    const ready = () => { if (dialog.querySelector('img') === img) dialog.removeAttribute('aria-busy'); };
    img.addEventListener('load',ready,{once:true});
    img.addEventListener('error',ready,{once:true});
    img.decoding = 'async';
    img.src = source;
    dialog.querySelector('[data-ap-figure-grand]').replaceChildren(img);
    dialog.querySelector('figcaption').textContent = button ? button.dataset.apFigureLegende || '' : image.closest('figure')?.querySelector('figcaption')?.textContent || '';
    trigger = button || document.activeElement;
    dialog.showModal();
  });
  document.addEventListener('close', event => {
    if (event.target.id !== 'ap-figure-dialog') return;
    event.target.querySelector('[data-ap-figure-grand]')?.replaceChildren();
    event.target.removeAttribute('aria-busy');
    if (trigger?.isConnected) trigger.focus({preventScroll:true});
    trigger = null;
  }, true);
  document.addEventListener('shopify:section:load', refresh);
  refresh();
})();
